import {
  Input,
  Row,
  Col,
  Divider,
  DatePicker,
  Space,
  Checkbox,
  Select,
  Tooltip,
  Radio, Upload, Button, message
} from "antd";
import React, { useState, useEffect } from "react";
import { FaUserAlt } from "react-icons/fa";
import { IoInformationCircleSharp } from "react-icons/io5";
import { GoDeviceMobile, GoPackage } from "react-icons/go";
import { MdEmail, MdOutlineFileUpload } from "react-icons/md";
import { IoIosCloseCircleOutline } from "react-icons/io";
import { FaFilePdf, FaFileImage } from "react-icons/fa";
import "./carform.scss";
import moment from "moment";
import { colorScheme, reservedStatus } from "../../contants/variables";
import { getCommaSeparatedTwoDecimalsNumber } from "../../stores/utils/formatNumber";
import { postVideo, uploadFile } from "../../stores/api_calls/upload";
import { error, success } from "../../contants/snackbars";
import { fetchSiteSetting } from "../../stores/api_calls/about";

const FieldSuffix = (props) => {
  const { TooltipData } = props;
  return (
    <Tooltip
      title={() => {
        return <TooltipData />;
      }}
      placement="bottomRight"
    >
      <IoInformationCircleSharp
        color={colorScheme.primary}
        style={{ fontSize: "20px" }}
      />
    </Tooltip>
  );
};

const CarDetails = (props) => {

  const [depreciation, setDepreciation] = useState(null);
  const [salesAgents, setSalesAgents] = useState([]);
  const [coeLeftYear, setCoeLeftYear] = useState("");
  const [coeLeftMonth, setCoeLeftMonth] = useState("");
  const [coeLeftDay, setCoeLeftDay] = useState("");
  const [checkRegDate, setCheckRegDate] = useState(true);
  const [videoFile, setVideoFile] = useState(null);
  const [SiteSetting, setSiteSetting] = useState("");
  const [fileListLogcard, setFileListLogcard] = useState([]);

  const {
    form,
    setForm,
    cities,
    brands,
    models,
    dealers,
    packages,
    isEdit,
    vehicleTypes,
    classifications,
    fuelTypes,
    ownerIdTypes,
    saleAdvisers,
  } = props;

  const [loan, setLoan] = useState({
    loanAmount: 0,
    loanPeriod: 0,
    loanPercentage: 0,
    loanInterest: 0,
    carPrice: 0,
    downPayment: 0,
  });

  useEffect(() => {
    getSiteSetting();
  }, []);

  useEffect(() => {
    // if(form.registrationDate && isEdit && checkRegDate === true) {
    //   autoCoeExpiryDate(form.registrationDate);
    // }
    if(form.registrationDate != null && isEdit ) {
      autoCoeLeftDate(form.coeExpiryDate);
    }
    
  }, [form.registrationDate != null, isEdit])

  useEffect(() => {
    setSalesAgents(form.productAgents);
  }, [form, isEdit])

  const getSiteSetting = () => {
      const fetchSetting = fetchSiteSetting({ id: "68240f5ae98421c57a0a5a43" });
      fetchSetting
        .then((res) => {
          if (res.data.success) {
              setSiteSetting(res?.data?.data);
          }
        })
        .catch((e) => {
          error("Failed to retrieve content");
        });
  };

  const handleUpdateAgent = (e) => {
    const { name, checked } = e.target;
    
    const contactNumber = name.contactnumber ? name.contactnumber : name.contactNumber;
    
    if(checked) {
      salesAgents.push({fullName: name.fullName, contactNumber : contactNumber});
    }else {
      salesAgents = salesAgents.filter((item)=> item.fullName != name.fullName);
    }
    console.log(salesAgents);
    setForm({ ...form, productAgents : salesAgents })
  };

  const handleFieldChange = (name, e) => {

    if(name == "engineCap") {
      let engineCap = e.target.value == "" ? 0 : e.target.value;
      if(engineCap.length <= 5 || engineCap == 0) {
        setForm({
          ...form,
          [name]: parseInt(engineCap),
        });
      }
    } else if(name == "power") {
      let power = e.target.value == "" ? 0 : e.target.value;
      if(power.length <= 6 || power == 0) {
        setForm({
          ...form,
          [name]: parseInt(power),
        });
      }
    } else if(name == "manufacturedYear") {
      let manufacturedYear = e.target.value == "" ? 0 : e.target.value;
      if(manufacturedYear.length <= 6 || manufacturedYear == 0) {
        setForm({
          ...form,
          [name]: parseInt(manufacturedYear),
        });
      }
    } else if(name == "numberOfOwners") {
      let numberOfOwners = e.target.value == "" ? 0 : e.target.value;
      if(numberOfOwners.length <= 6 || numberOfOwners == 0) {
        setForm({
          ...form,
          [name]: parseInt(numberOfOwners),
        });
      }
    } else {
      setForm({
        ...form,
        [name]: e.target.value,
      });
    }

  };
  
  const handleNumberFieldChange = (name, e, maxLength = 7) => {

    if(name == "arf") {
      let arf = e;
      if(arf && form.askingPrice) {
        calculateDepreciation(form.askingPrice, arf, form.registrationDate, form.coeExpiryDate, coeLeftYear, coeLeftMonth, coeLeftDay)
      }
      if(arf && arf > 0) {
        if(coeLeftYear > 0 && coeLeftMonth > 0) {
          form.deregValue = arf/2;
        } else {
          form.deregValue = 0;
        }
      }
    }
    if(name == 'askingPrice') {
      // console.log(e)
      let askingPrice = e;
      if(form.arf && askingPrice) {
        setLoan({
          ...loan, 
          loanAmount: askingPrice * (SiteSetting.loan_percent/100),
          carPrice: askingPrice,
          downPayment: askingPrice * ((100 - SiteSetting.loan_percent)/100),
        })

        calculateDepreciation(askingPrice, form.arf, form.registrationDate, form.coeExpiryDate, coeLeftYear, coeLeftMonth, coeLeftDay)
      }
    }

    if(e.length <= maxLength || e == 0) {
      setForm({
        ...form,
        [name]: e,
      });
    }
    
  };

  const handleSelectPackage = (value) => {
    setForm({ ...form, packageId: value });
  };

  const onDateFieldChange = (name, dateString) => {

    if(name == "registrationDate") {
      autoCoeExpiryDate(dateString);
    }

    if(name == "coeExpiryDate") {
      autoCoeLeftDate(dateString);
    }

    setForm({ ...form, [name]: dateString });
  };

  const autoCoeExpiryDate = (dateString) => {
    let regDate = moment(dateString);
    let coeDate = regDate.add(10, 'y').subtract(1, 'days');
    let nowDate = moment();
    let years = coeDate.diff(nowDate, 'years');
    nowDate.add(years, 'years');
    let months = coeDate.diff(nowDate, 'months');
    nowDate.add(months, 'months');
    let days = coeDate.diff(nowDate, 'days');
    const coeLeftDate = years + ' years ' + months + ' months ' + days + ' days';
    form.coeLeftDate = coeLeftDate;
    form.coeExpiryDate = coeDate;
    
    setForm({...form, coeExpiryDate: coeDate, coeLeftDate: coeLeftDate})
    setCoeLeftYear(years);
    setCoeLeftMonth(months);
    setCoeLeftDay(days);
    if(checkRegDate == false) {
      calculateDepreciation(form.askingPrice, form.arf, dateString, coeDate, years, months, days);
    }
    setCheckRegDate(false);
  }

  const autoCoeLeftDate = (dateString) => {
    let coeDate = moment(dateString);
    let nowDate = moment();
    let years = coeDate.diff(nowDate, 'years');
    nowDate.add(years, 'years');
    let months = coeDate.diff(nowDate, 'months');
    nowDate.add(months, 'months');
    let days = coeDate.diff(nowDate, 'days');
    const leftDate = years + ' years ' + months + ' months ' + days + ' days';
    form.coeLeftDate = leftDate;
    setForm({...form, coeLeftDate: leftDate})

    const loanPeriodMonth = (years * 12) + months;
    
    setLoan({
      ...loan, 
      loanAmount: form.askingPrice * (SiteSetting.loan_percent/100),
      loanPeriod: loanPeriodMonth <= 84 ? loanPeriodMonth : 84,
      loanPercentage: SiteSetting.loan_percent,
      loanInterest: form.is_commercial_vehicle ? SiteSetting.commercial_interest_rate_percent : SiteSetting.interest_rate_percent,
      carPrice: form.askingPrice,
      downPayment: form.askingPrice * ((100 - SiteSetting.loan_percent)/100),
    });

    setCoeLeftYear(years);
    setCoeLeftMonth(months);
    setCoeLeftDay(days);
    calculateDepreciation(form.askingPrice, form.arf, form.registrationDate, dateString, years, months, days);
  }

  const onCheckboxChange = (name, e) => {
    setForm({
      ...form,
      [name]: e.target.checked,
    });
  };

  const handleDropdownChange = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
  };

  const isOverTenYears = (regDate, coeDate) => {
    const diffInYears = Math.abs(moment(regDate).diff(moment(coeDate), 'years'));
    console.log(diffInYears);
    return diffInYears > 10;
  };

  const calculateDepreciation = (askingPrice, arfVAlue, registrationDate, coeExpiryDate, coeYear, coeMonth, coeDay) => {
    const overTenYear = isOverTenYears(registrationDate, coeExpiryDate);

    if(!overTenYear) {
      form.depreciationValue = "";
      let coeDate = moment(form.coeExpiryDate);
      let nowDate = moment();
      let leftMonths = coeDate.diff(nowDate, 'months');

      let halfArf = arfVAlue / 2;
      let leftPrice = askingPrice - halfArf;
      let totalMonthPrice = leftPrice / leftMonths;
      let result = totalMonthPrice * 12;
      
      form.depreciationValue = result > 0 ? result.toFixed(0) : 0;
      setForm({ ...form, depreciationValue: result > 0 ? result.toFixed(0) : 0});
    }else {
      form.depreciationValue = "";
      const calculatedMonths = (Number(coeYear) * 12) + Number(coeMonth);
      console.log('price : '+askingPrice);
      console.log('totalMonth : '+calculatedMonths);
      let result = (Number(askingPrice) / calculatedMonths) * 12;
      form.depreciationValue =result > 0 ? result.toFixed(0) : 0;
      console.log(result);
      setForm({ ...form, depreciationValue: result > 0 ? result.toFixed(0) : 0});
    }
  }

  useEffect(() => {
    if(form.coeLeftDate != null ) {
      calculateLoan();
    }
  }, [SiteSetting, form.askingPrice, form.coeLeftDate, loan.loanAmount]);

  const calculateLoan = () => {
    const { loanAmount, loanInterest, loanPeriod } = loan;
    let installment = 0;

    if(loanAmount) {
      installment = Math.floor(
        ((parseFloat(loanAmount) *
          (parseFloat(loanInterest) / 100) *
          (parseInt(loanPeriod)/12)) +
          parseFloat(loanAmount)) /
          parseInt(loanPeriod)
      );
    } else {
      installment = 0;
    }
    
    form.monthly_installment_price = installment;

    setForm({ ...form, monthly_installment_price: installment});
  };

  const handleRadioChange = (key, e) => {
    setForm((prev) => ({ ...prev, [key]: e.target.value }));
  };

  const handleChangeVideo = ({ videoFile: newVideoList }) => {
    setVideoFile(newVideoList);
  };

  const handleVideoFileUpload = async ({file, onSuccess, onError}) => {
    
    try {
      const res = await postVideo(file);
      
      if (res?.data?.success) {
        onSuccess(null, file);
        setForm({ ...form, localVideoUrl: res?.data?.data?.metadata?.file_url });
        // setVideoFile(res?.data?.metadata?.file_url);
      } else {
        throw new Error('Upload failed');
      }
    } catch (e) {
      onError(e);
      error(
        e.message || 'Upload failed!'
      );
      console.log(e);
    }
  }

  const beforeUploadVideo = async (file) => {
    const isMP4 = file.type === 'video/mp4';

    if (!isMP4) {
      error('Only MP4 files are allowed!');
      setForm({ ...form, localVideoUrl: null });
      setVideoFile([]);
      return Upload.LIST_IGNORE; // Prevent the file from being added to the list
    }

    const isValid = await validateVideoDuration(file);
    if (!isValid) {
      error('Video duration must not exceed 3 minutes!');
      setForm({ ...form, localVideoUrl: null });
      setVideoFile([]);
      return false;
    }

    const previewURL = URL.createObjectURL(file);
    setForm({ ...form, localVideoUrl: previewURL });

    return true; // Allow the upload
  }

  const validateVideoDuration = (file) => {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        URL.revokeObjectURL(video.src);
        resolve(video.duration <= 180); // Check if duration is <= 60 seconds
      };

      video.onerror = () => {
        error('Unable to load video metadata.');
        resolve(false);
      };

      video.src = URL.createObjectURL(file);
    });
  };

  const handleClear = () => {
    setForm({ ...form, localVideoUrl: null });
    setVideoFile(null);
  };


  const beforeUploadLogcard = (file) => {
      const isImageOrPdf = file.type.startsWith('image/') || file.type === 'application/pdf';
      if (!isImageOrPdf) {
          message.error('You can only upload image or PDF file!');
          return Upload.LIST_IGNORE;
      }
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isLt10M) {
          message.error('File must be smaller than 10MB!');
          return Upload.LIST_IGNORE;
      }

      return true;
  };

  const handleChangeLogcard = ({ fileList }) => {
    setFileListLogcard(fileList);
  };

  const handleUploadLogcard = async (options) => {
    
    const { file, onProgress, onError, onSuccess } = options;
    
    try {
      const res = await uploadFile(file);
      
      if (res?.data?.success) {
        onSuccess(res.data.data);
        setForm({ ...form, attachLogcardUrl: res?.data?.data?.metadata?.file_url });
      } else {
        throw new Error('Upload failed');
      }
    } catch (error) {
      onError(error);
      message.error('Upload failed attach logcard!');
      console.error(error);
    }
  };


  return (
    <div>
      <div className="header-container">
        <p className="header">Dealer Personal Details</p>
        <p className="sub-header">
          Note: (<span className="text-color-danger">*</span>) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Name <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.fullname || undefined}
              loading={dealers.loading}
              onChange={(value) => handleDropdownChange("dealerId", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {[
                {
                  user_first_name: "NOT ON THE LIST DEALER",
                  user_last_name: "",
                  _id: "0",
                },
                {
                  user_first_name: "NOT ON THE LIST DIRECT SELLER",
                  user_last_name: "",
                  _id: "1",
                },
                ...dealers.data,
              ].map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {`${el.user_first_name} ${el.user_last_name}`}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Mobile Number <span>*</span> :{" "}
            </p>
            <Input
              value={form.dealerMobileNumber}
              prefix={<GoDeviceMobile />}
              onChange={(text) => handleFieldChange("dealerMobileNumber", text)}
              disabled={
                form.dealerId === "0" || form.dealerId === "1" ? false : true
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Email:</p>
            <Input
              value={form.dealerEmail}
              prefix={<MdEmail />}
              onChange={(text) => handleFieldChange("dealerEmail", text)}
              disabled={
                form.dealerId === "0" || form.dealerId === "1" ? false : true
              }
            />
          </div>
        </Col>
      </Row>

      {(form.dealerId === "0" || form.dealerId === "1") && (
        <Row>
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">
                First Name <span>*</span> :{" "}
              </p>
              <Input
                value={form.dealerFirstName}
                onChange={(text) => handleFieldChange("dealerFirstName", text)}
              />
            </div>
          </Col>
          <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">Last Name: </p>
              <Input
                value={form.dealerLastName}
                onChange={(text) => handleFieldChange("dealerLastName", text)}
              />
            </div>
          </Col>
        </Row>
      )}

      <Divider />

      {form.role === "Advertiser" ? (
        <div>
          <div className="header-container">
            <p className="header">Package Options</p>
            <p className="sub-header">
            Note: (<span className="text-color-danger">*</span>) for advertisers they must select a plan
            </p>
          </div>
          <Row>
            {packages.map((item, index) => (
              <>
              {index == 0 && (
                <Col span={8} key={index}>
                  <div
                    className={`package-card-container ${
                      form.packageId === item._id ? "active" : ""
                    }`}
                    onClick={() => handleSelectPackage(item._id)}
                  >
                    <div className="package-title">
                      <p>{item.package_name}</p>
                      <p>S$ {item.package_cost}</p>
                    </div>
                  </div>
                </Col>
              )}
              </>
            ))}
          </Row>
          <Divider />
        </div>
      ) : null}

      <div className="header-container">
        <p className="header">Bike Details</p>
        <p className="sub-header">
          Note: (<span className="text-color-danger">*</span>) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
            Bike Plate Number <span>*</span> :{" "}
            </p>
            <Input
              value={form.plateNumber.toUpperCase()}
              onChange={(text) => handleFieldChange("plateNumber", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p style={{ fontSize: "9px" }}>
                      This bike plate number field will not be shown in the ad.
                      It is for verification purpose.
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Access Code <span>*</span> :{" "}
            </p>
            <Input
              maxLength={6}
              value={form.accessCode}
              onChange={(text) => handleFieldChange("accessCode", text)}
              // onChange={(e) => {
              //   handleNumberFieldChange(
              //     "accessCode",
              //     e.target.value == "" ? 0 : e.target.value.split(",").join("")
              //   );
              // }}
              suffix={
                <FieldSuffix
                  tooltipWidth={350}
                  TooltipData={() => (
                    <div style={{fontSize:11}}>
                      <p>From 30 June 2025, LTA will replace the use of the last 4 characters 
                      of the vehicle owner's ID with a 6-digit access code for selected digital services.</p>
                      <div style={{marginBottom:10}}><strong>How to request your access code:</strong></div>
                      <ul style={{paddingLeft:15, listStyleType:'decimal'}}>
                          <li> Visit <strong><a href="https://vrl.lta.gov.sg/lta/vrl/action/pubfunc?ID=EnquireRebateBeforeDeReg" target="_blank">OneMotoring</a></strong> website. </li>
                          <li> Under "Popular Digital Services", click Request Access Code and login using Singpass. </li>
                          <li> Select vehicle and enter your mobile number of email to receive the code. </li>
                          <li> You will receive the code on-screen and via SMS/email. </li>
                          <li> Enter the 6-digit in the Sgcarlist from to allow us to retrieve your vehicle details. </li>
                      </ul>

                      <p>For more info visit <strong><a href="https://vrl.lta.gov.sg/lta/vrl/action/pubfunc?ID=EnquireRebateBeforeDeReg" target="_blank">here.</a></strong></p>
                    </div>
                  )}
                />
              }
            />
          </div>
        </Col>
        <Col>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> If No Access Code :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    If Not Access Code, please attach logcard so that we can upload your used bike details
                  </p>
                )}
              />
            </div>
            {!form.attachLogcardUrl ? (
              <Upload
                customRequest={handleUploadLogcard}
                beforeUpload={beforeUploadLogcard}
                onChange={handleChangeLogcard}
                fileList={fileListLogcard}
                multiple={false}
                accept="image/*,.pdf"
                maxCount={1}
              >
                <Button 
                  type="primary" 
                  ghost
                  icon={<MdOutlineFileUpload />}
                >
                  Upload PDF or Image
                </Button>
              </Upload>
            ):(
              <>
              {form.attachLogcardUrl.endsWith('.pdf') ? (
                <a
                    href={form.attachLogcardUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    download // optional: will trigger direct download
                >
                  <FaFilePdf style={{marginRight:5,color:'red'}} />
                  <span>Download Attach Logcard PDF File</span>
                </a>
              ):(
                <a href={form.attachLogcardUrl} target="_blank" rel="noopener noreferrer">
                  <FaFileImage style={{marginRight:5,color:'black'}} />
                  Download Attach Logcard Image File
                </a>
              )}
              </>
            )}
          </div>
        </Col>
        
        {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Owner ID Type <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.ownerIdType || undefined}
              onChange={(value) => handleDropdownChange("ownerIdType", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {ownerIdTypes.map((el, i) => (
                <Select.Option key={i} value={el.label}>
                  {el.label}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col> */}
        {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Owner ID <span>*</span> :{" "}
            </p>
            <Input
              maxLength={4}
              value={form.ownerId.toUpperCase()}
              onChange={(text) => handleFieldChange("ownerId", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p style={{ fontSize: "9px" }}>
                      The identification number of the registered owner of
                      vehicle.
                      <br />
                      We only require the last 4 characters.
                      <br />
                      <br />
                      eg: If the identification number is S1234567A, simply
                      input 567A"
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col> */}
      </Row>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Registration Date <span>*</span> :{" "}
            </p>
            <Space>
              <div className="datepicker">
                <DatePicker
                  format="DD-MMM-YYYY"
                  style={{ width: "100%" }}
                  // value={moment('01/01/2000', 'DD-MM-YYYY')}
                  value={
                    isNaN(Date.parse(form.registrationDate)) ||
                    !form.registrationDate
                      ? moment('01/01/2010', 'DD-MM-YYYY')
                      : moment(form.registrationDate)
                  }
                  onChange={(date, dateString) =>
                    onDateFieldChange("registrationDate", dateString)
                  }
                />
              </div>
            </Space>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              COE Expiry Date <span>*</span> :{" "}
            </p>
            <Space>
              <div className="datepicker">
                <DatePicker
                  format="DD-MMM-YYYY"
                  style={{ width: "100%" }}
                  value={form.coeExpiryDate ? moment(form.coeExpiryDate) : null}
                  onChange={(date, dateString) =>
                    onDateFieldChange("coeExpiryDate", dateString)
                  }
                />
              </div>
            </Space>
          </div>
        </Col>
        <Col span={8}>
            <div className="form-fields">
              <p className="form-field-label">
                COE Left Date
              </p>
              <Input
                value={form.coeLeftDate}
                disabled
              />
            </div>
        </Col>
        
      </Row>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              COE <span>*</span> :{" "}(N.A)
            </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.coe)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "coe",
                  e.target.value == "" ? 0 : e.target.value.split(",").join("")
                );
              }}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              OMV <span>*</span> :{" "}(N.A)
            </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.omv)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "omv",
                  e.target.value == "" ? 0 : e.target.value.split(",").join("")
                );
              }}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              ARF <span>*</span> :{" "}(N.A)
            </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.arf)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "arf",
                  e.target.value == "" ? 0 : e.target.value.split(",").join("")
                );
              }}
            />
          </div>
        </Col>
        
      </Row>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Selling Price <span>*</span> :{" "}
            </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.askingPrice)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "askingPrice",
                  e.target.value == "" ? 0 : e.target.value.split(",").join("")
                );
              }}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Est Mth Instl. :
            </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.monthly_installment_price)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "monthly_installment_price",
                  e.target.value == "" ? 0 : e.target.value.split(",").join(""),
                  5
                );
              }}
              max={3}
            />
          </div>
        </Col>
        {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Reserved Status :
            </p>
            <Select
              value={form.reserved_status}
              onChange={(value) => handleDropdownChange("reserved_status", value)}
              style={{ width: "100%" }}
              placeholder="- Please Select -"
              options={reservedStatus}
            />
          </div>
        </Col> */}
        
        <Col span={8}>
          <div className="form-fields">
              <p className="form-field-label">Depreciation Value : (N.A) </p>
              <Input
                value={getCommaSeparatedTwoDecimalsNumber(form.depreciationValue)}
                onChange={(e) => {
                  handleNumberFieldChange(
                    "depreciationValue",
                    e.target.value === "" ? 0 : e.target.value.split(",").join("")
                  );
                }}
              />
            </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            {/* <p className="form-field-label">Deregistered Value : </p> */}
            <p className="form-field-label">Min. PARF : (N.A) </p>
            <Input
              value={form.deregValue}
              onChange={(text) => handleFieldChange("deregValue", text)}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Road Tax : </p>
            <Input
              prefix={
                <div className="fieldPrefix">
                  <p>S$</p>
                </div>
              }
              value={getCommaSeparatedTwoDecimalsNumber(form.roadTax)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "roadTax",
                  e.target.value == "" ? 0 : e.target.value.split(",").join("")
                );
              }}
            />
          </div>
        </Col>
      </Row>

      <Row>        
        <Col span={8}>
            <div className="form-fields" style={{ marginTop: "10px" }}>
              <p>
                For verifying the COE,ARF,OMV kindly visit{" "}
                <a href="https://onemotoring.lta.gov.sg/" target="_blank">
                  One Motoring
                </a>
              </p>
            </div>
        </Col>
      </Row>

      <Divider />

      <div className="header-container">
        <p className="header">Bike Informations</p>
        <p className="sub-header">
          Note: (<span className="text-color-danger">*</span>) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
            Bike Name <span>*</span> :{" "}
            </p>
            <Input
              value={form.carName}
              onChange={(text) => handleFieldChange("carName", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p style={{ fontSize: "9px" }}>
                      Name of the bike to be displayed in website
                      <br />
                      eg: For SALE Toyota 40% Discount.
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
            Bike Brand <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.carBrand || undefined}
              loading={brands.loading}
              onChange={(value) => handleDropdownChange("carBrand", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {brands.data.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {el.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
            Bike Model <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.carModel || undefined}
              disabled={!models.data.length}
              loading={models.loading && form.carBrand}
              onChange={(value) => handleDropdownChange("carModel", value)}
              style={{ width: "100%" }}
              placeholder={
                models.loading
                  ? `Fetching list of models`
                  : !models.data.length
                  ? `No model available in this brand`
                  : `Search to Select`
              }
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {models.data.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {el.name}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Engine Cap <span>*</span> :{" "}
            </p>
            <Input
              maxLength={5}
              type="number"
              min="0"
              step="1"
              value={form.engineCap}
              onChange={(text) => handleFieldChange("engineCap", text)}
              // disabled = {!form.isManualInput}
              suffix={
                <div className="fieldPrefix">
                  <p>CC</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Power : </p>
            <Input
              maxLength={6}
              type="number"
              min="0"
              step="1"
              value={form.power}
              onChange={(text) => handleFieldChange("power", text)}
              suffix={
                <div className="fieldPrefix">
                  <p>kW</p>
                </div>
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Vehicle / Body Type : </p>
            <Select
              showSearch
              value={form.vehicleType}
              onChange={(value) => handleDropdownChange("vehicleType", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select."
              options={vehicleTypes}
            />
          </div>
        </Col>
        {/* <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
            Bike Condition <span>*</span> :{" "}
            </p>
            <Select
              showSearch
              value={form.condition || undefined}
              onChange={(value) => handleDropdownChange("condition", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              <Select.Option value="Used"> Used Bike</Select.Option>
              <Select.Option value="New"> Brand New Bike</Select.Option>
            </Select>
          </div>
        </Col> */}
      </Row>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Ownership <span>*</span> :{" "}
            </p>
            <Input
              type="number"
              min="0"
              step="1"
              value={form.numberOfOwners}
              onChange={(text) => handleFieldChange("numberOfOwners", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p style={{ fontSize: "9px" }}>
                      If brand new put 0 , else put the number of owners
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              {/* Edition Year Manufactured <span>*</span> :{" "} */}
              Manufacturing Year <span>*</span> :{" "}
            </p>
            <Input
              placeholder="YYYY"
              type="number"
              value={form.manufacturedYear}
              onChange={(text) => handleFieldChange("manufacturedYear", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p style={{ fontSize: "9px" }}>
                      The manufactured year of the bike
                      <br />
                      <br />
                      e.g : 2020
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Pri Color : </p>
            <Select
              showSearch
              value={form.color ?? undefined}
              onChange={(value) => handleDropdownChange("color", value)}
              style={{ width: "100%" }}
              placeholder="Select Color."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              <Select.Option value="black">Black</Select.Option>
              <Select.Option value="grey">Grey</Select.Option>
              <Select.Option value="white">White</Select.Option>
              <Select.Option value="beige">Beige</Select.Option>
              <Select.Option value="gold">Gold</Select.Option>
              <Select.Option value="red">Red</Select.Option>
              <Select.Option value="blue">Blue</Select.Option>
              <Select.Option value="yellow">Yellow</Select.Option>
              <Select.Option value="green">Green</Select.Option>
              <Select.Option value="orange">Orange</Select.Option>
              <Select.Option value="pink">Pink</Select.Option>
              <Select.Option value="purple">Purple</Select.Option>
              <Select.Option value="brown">Brown</Select.Option>
              <Select.Option value="silver">Silver</Select.Option>
              <Select.Option value="maroon">Maroon</Select.Option>
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Classification : </p>
            <Select
              showSearch
              value={form.classification}
              onChange={(value) => handleDropdownChange("classification", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select."
              options={classifications}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div className="label-with-tooltip">
              <p className="form-field-label"> Option Label :</p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Label shall be displayed on the picture of bike.
                  </p>
                )}
              />
            </div>
            <Select
              value={form.option_label_1}
              onChange={(value) => handleDropdownChange("option_label_1", value)}
              style={{ width: "100%" }}
              placeholder="-- Select --"
              options={[
                // { value: 'High Trade In', label: 'High Trade In' },
                { value: '$0 Downpayment', label: '$0 Downpayment' },
                { value: '1 Owner', label: '1 Owner' },
                { value: 'COE Bike', label: 'COE Bike' },
                { value: 'Low Mileage', label: 'Low Mileage' },
                { value: 'Electric Bike', label: 'Electric Bike' },
                // { value: 'Reserved', label: 'Reserved' },
                // { value: 'Pre-Owned', label: 'Pre-Owned' },
                // { value: 'Consignment', label: 'Consignment' },
                // { value: 'COE Bike', label: 'COE Bike' },
                // { value: 'Showroom Unit', label: 'Showroom Unit' },
              ]}
              allowClear
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <div style={{marginBottom: 10,}}>
              <Radio.Group 
                onChange={(e) => handleRadioChange("videoType", e)} 
                value={form.videoType}
              >
                <Radio value="tiktok">Tiktok</Radio>
                <Radio value="youtube">Youtube</Radio>
                <Radio value="local">Local Drive</Radio>
              </Radio.Group>
            </div>

            {form?.videoType == "tiktok" ? (
              <>
                {/* <p className="form-field-label">Video Link : </p> */}
                <Input
                  value={form.tiktokVideo}
                  onChange={(text) => handleFieldChange("tiktokVideo", text)}
                  placeholder="Tiktok Video Link - Optional"
                />
                <p className="form-field-label" style={{color:colorScheme.red, fontSize:12, marginTop:3}}>Video duration must not exceed 3 minutes!</p>
              </>
            ): form?.videoType == "youtube" ? (
              <>
                {/* <p className="form-field-label">Video Link : </p> */}
                <Input
                  value={form.youtubeVideo}
                  onChange={(text) => handleFieldChange("youtubeVideo", text)}
                  placeholder="Youtube Video Link - Optional"
                />
                <p className="form-field-label" style={{color:colorScheme.red, fontSize:12, marginTop:3}}>Video duration must not exceed 3 minutes!</p>
              </>
            ): (
              <>
                
                <div style={{display:'flex', justifyContent:'space-between'}}>
                  {!form.localVideoUrl && (
                    <div>
                      <Upload
                        accept="video/mp4"
                        onChange={handleChangeVideo}
                        customRequest={handleVideoFileUpload}
                        beforeUpload={beforeUploadVideo}
                        fileList={videoFile}
                      >
                        <Button type="primary">
                          <MdOutlineFileUpload style={{marginRight:10}} /> <span>Upload Video</span>
                        </Button>
                      </Upload>
                      <p className="form-field-label" style={{color:colorScheme.red, fontSize:12, marginTop:3}}>Video duration must not exceed 3 minutes!</p>
                    </div>
                  )}

                  {form.localVideoUrl && (
                    <div style={{ marginLeft: '20px',display:'flex' }}>
                      <video
                        src={form.localVideoUrl}
                        controls
                        width="150"
                        style={{ border: '1px solid #ccc', borderRadius: '4px' }}
                      />
                      <IoIosCloseCircleOutline
                      onClick={handleClear}
                      style={{color:'red',fontSize:20,cursor:'pointer'}}
                      />
                    </div>
                  )}
                </div>
              </>
            )}

            
          </div>
        </Col>
      </Row>
      {/* <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Tiktok Video Link : </p>
            <Input
              value={form.tiktokVideo}
              onChange={(text) => handleFieldChange("tiktokVideo", text)}
            />
          </div>
        </Col>
      </Row> */}
      <Row>
        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isVerified}
              onChange={(e) => onCheckboxChange("isVerified", e)}
            >
              Is Verified
            </Checkbox>
          </div>
        </Col>
        
        <Col span={8}>
          <div className="form-fields">
            <Checkbox
              valuePropName="checked"
              checked={form.isSendEmail}
              onChange={(e) => onCheckboxChange("isSendEmail", e)}
            >
              Is Send Email
            </Checkbox>
          </div>
        </Col>
      </Row>

      {isEdit && (
        <>
        <Divider />

        <div className="header-container">
          <p className="header">Sale Advisers</p>
        </div>

        <Row>
          {saleAdvisers?.map((item, i) => (
            <Col span={8}>
              <div className="form-fields" style={{ margin: 0 }}>
                <Checkbox
                  name={item}
                  checked={form?.productAgents?.find(agent => agent.fullName === item.fullName)}
                  onChange={(e) => handleUpdateAgent(e)}
                  disabled
                >
                  {item.fullName} - {item?.sorting}
                </Checkbox>
              </div>
            </Col>
          ))}
        </Row>
        </>
      )}

      <Divider />

      {/* <div className="header-container">
        <p className="header">Viewing Location</p>
        <p className="sub-header">
          Note: (<span className="text-color-danger">*</span>) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Pickup Address : </p>
            <Input
              value={form.address}
              onChange={(text) => handleFieldChange("address", text)}
              suffix={
                <FieldSuffix
                  TooltipData={() => (
                    <p style={{ fontSize: "9px" }}>
                      Complete address where to pick-up the bike.
                      <br />
                      This is an important field for filtering bikes in the
                      system and analytics.
                    </p>
                  )}
                />
              }
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              City , Region :{" "}
            </p>
            <Select
              showSearch
              value={form.cityId || undefined}
              disabled={!cities.data}
              loading={cities.loading}
              onChange={(value) => handleDropdownChange("cityId", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select"
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {cities.data.map((el, i) => (
                <Select.Option key={i} value={el._id}>
                  {`${el.city}, ${el.region_name}`}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
      </Row>

      <Divider /> */}

      <div className="header-container">
        <p className="header">Bike Specifications</p>
        <p className="sub-header">
          Note: (<span className="text-color-danger">*</span>) fields are required to be filled up
        </p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Transmission <span></span> :{" "}
            </p>
            <Select
              showSearch
              value={form.transmission || undefined}
              onChange={(value) => handleDropdownChange("transmission", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              <Select.Option value={"Automatic"}>Automatic</Select.Option>
              <Select.Option value={"Manual"}>Manual</Select.Option>
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Fuel Type <span></span> :{" "}
            </p>
            <Select
              showSearch
              value={form.fuelType || undefined}
              onChange={(value) => handleDropdownChange("fuelType", value)}
              style={{ width: "100%" }}
              placeholder="Search to Select."
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
              filterSort={(optionA, optionB) =>
                optionA.children
                  .toLowerCase()
                  .localeCompare(optionB.children.toLowerCase())
              }
            >
              {fuelTypes.map((fuel, i) => (
                <Select.Option key={i} value={fuel}>
                  {fuel}
                </Select.Option>
              ))}
            </Select>
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Mileage <span>*</span> :{" "}
            </p>
            <Input
              value={getCommaSeparatedTwoDecimalsNumber(form.mileage)}
              onChange={(e) => {
                handleNumberFieldChange(
                  "mileage",
                  e.target.value == "" ? 0 : e.target.value.split(",").join("")
                );
              }}
              suffix={
                <div className="fieldPrefix">
                  <p>km</p>
                </div>
              }
            />
          </div>
        </Col>
      </Row>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="form-field-label">
                Description <span>*</span> :{" "}
              </p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Description will appear in the main page, so it is the most
                    important comment to add.
                    <br />
                    <br />
                    eg: Urgent sales; 1 careful owner; Seldom driven; high Parf
                    rebate; New road tax; Regularly servicing at Agent; Price
                    negotiable; Please call to arrange a test-drive etc...
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.description}
              onChange={(text) => handleFieldChange("description", text)}
            />
          </div>
        </Col>

        {/* <Col span={8}>
          <div className="form-fields">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="form-field-label">
                Features <span>*</span> :{" "}
              </p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Features refers to functions in-built in your vehicle.
                    <br />
                    <br />
                    eg: ABS, EBD, Air-Bags, Sun-roof, Immobilizer, Keyless
                    Entry, VVT-i engine, Turbo-charger etc...
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.features}
              onChange={(text) => handleFieldChange("features", text)}
            />
          </div>
        </Col> */}
        <Col span={8}>
          <div className="form-fields">
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <p className="form-field-label">
                Accessories <span>*</span> :{" "}
              </p>
              <FieldSuffix
                TooltipData={() => (
                  <p style={{ fontSize: "9px" }}>
                    Accessories refers to additional luxuries to your vehicle.
                    <br />
                    <br />
                    eg: Body kit, Spoiler, Leather Seats, Sports Rim,
                    CD-Changer, Reverse Sensors, Sports Seats, Racing clutch,
                    V-kool, HID headlights, VCD player, LCD TV etc...
                  </p>
                )}
              />
            </div>
            <Input.TextArea
              rows={8}
              value={form.accessories}
              onChange={(text) => handleFieldChange("accessories", text)}
            />
          </div>
        </Col>
      </Row>

      {/* <Divider /> */}

      {/* <div className="header-container">
        <p className="header">Optional Details</p>
      </div>

      <Row>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Vehicle Number : </p>
            <Input
              value={form.vehicleNumber}
              onChange={(text) => handleFieldChange("vehicleNumber", text)}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Vehicle Unit Number : </p>
            <Input
              value={form.vehicleUnitNumber}
              onChange={(text) => handleFieldChange("vehicleUnitNumber", text)}
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">Vehicle Reference Number : </p>
            <Input
              value={form.vehicleReferenceNumber}
              onChange={(text) =>
                handleFieldChange("vehicleReferenceNumber", text)
              }
            />
          </div>
        </Col>
        <Col span={8}>
          <div className="form-fields">
            <p className="form-field-label">
              Vehicle Registration Card Number :{" "}
            </p>
            <Input
              value={form.vehicleRegistrationCardNumber}
              onChange={(text) =>
                handleFieldChange("vehicleRegistrationCardNumber", text)
              }
            />
          </div>
        </Col>

        <Col span={8}>
          <div className="form-fields" style={{ margin: "32px 0px" }}>
            <Checkbox
              valuePropName="checked"
              checked={form.isOffPeak}
              onChange={(e) => onCheckboxChange("isOffPeak", e)}
            >
              Tick if the bike is an Off-Peak Bike
            </Checkbox>
          </div>
        </Col>
      </Row> */}

    </div>
  );
};

export default CarDetails;
